import styled, { css, keyframes } from 'styled-components';

export const PositionContext = styled.div`
  position: relative;
`;

export const popoverEnter = keyframes`
to {
  opacity: 1;
  transform: scale(1) translate3d(0, 0, 0);
}
`;

const getTransition = (position) => {
  switch (position) {
    case 'top':
      return css`
        transform-origin: bottom center;
      `;
    case 'bottom':
      return css`
        transform-origin: top center;
      `;
    case 'right':
      return css`
        transform-origin: left center;
      `;
    case 'left':
      return css`
        transform-origin: right center;
      `;
    case 'bottom-start':
      return css`
        transform-origin: top left;
      `;
    case 'bottom-end':
      return css`
        transform-origin: top right;
      `;
    case 'top-start':
      return css`
        transform-origin: bottom left;
      `;
    case 'top-end':
      return css`
        transform-origin: bottom right;
      `;
    case 'left-start':
      return css`
        transform-origin: top right;
      `;
    case 'left-end':
      return css`
        transform-origin: bottom right;
      `;
    case 'right-start':
      return css`
        transform-origin: top left;
      `;
    case 'right-end':
      return css`
        transform-origin: bottom left;
      `;
    default:
      return css`
        transform-origin: top left;
      `;
  }
};

export const Anchor = styled.button`
  height: 40px;
  width: 100px;
  color: var(--cc_color_text_default);
  background: var(--cc_color_button_background_subtle);
  border-width: 0;
  border-radius: var(--cc_size_border_radius_l);
`;

export const FloatPosition = styled.div`
  position: absolute;
  z-index: 800;
  opacity: 0;
  transform: scale(0.9) translate3d(0, 0, 0);
  animation-name: ${popoverEnter};
  animation-delay: 0.1s;
  animation-duration: 0.25s;
  animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  animation-fill-mode: forwards;

  @media (min-width: 500px) {
    transform: scale(0.9) translate3d(0, 0, 0);
    ${(props) => getTransition(props.position)},
  }
`;

export const Tooltip = styled.div`
  font-weight: bold;
  font-size: var(--cc_size_text_s);
  color: var(--cc_color_text_default);
  background: var(--cc_color_background_3);
  padding: var(--cc_size_spacing_m) var(--cc_size_spacing_l);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  border-radius: var(--cc_size_border_radius_l);
  transition: all ease-in-out 100ms;
`;

export const Arrow = styled.div`
  position: absolute;
  background: var(--cc_color_background_3);
  width: var(--cc_size_spacing_m);
  height: var(--cc_size_spacing_m);
  transform: rotate(45deg);
`;
